import appConfig from 'src/utils/appConfig';
import getOauthUrl from 'src/utils/getOauthUrl';
import interpolate from 'src/utils/interpolate';
import getLoginURL from './getLoginURL';

/*
 * urlBuilder() will return urls that are used in the handlebars template
 */
export default function(linkName) {
  let url = '';

  switch (linkName) {
    case 'facebook':
      url = getOauthUrl('facebook');
      break;
    case 'google':
      url = getOauthUrl('google');
      break;
    case 'login':
    case 'signin':
      url = interpolate(
        getLoginURL(),
        appConfig.serialize()
      );
      break;
    case 'registration':
      url = interpolate(
        appConfig.getMyConfig().registrationUrl,
        appConfig.serialize()
      );
      break;
    case 'index':
      url = interpolate(
        appConfig.getMyConfig().staticBaseUrlTemplate,
        appConfig.serialize()
      );
      break;
    // no default
  }

  return url;
}
